import React from 'react';
import ImageSlider from './ImageSlider';
import Product_slider1 from './Product_slider1';
// import ImageGallery from './ImageGallery';
import InfiniteLooper from './ImageGallery';


import img1 from '../Assets/products/Rectangle1.png';
import img2 from '../Assets/products/Rectangle2.png';
import img3 from '../Assets/products/Rectangle3.png';
import img4 from '../Assets/products/Rectangle4.png';
import img5 from '../Assets/products/Rectangle5.png';
import img6 from '../Assets/products/Rectangle6.png';
import img7 from '../Assets/products/Rectangle7.png';
import img8 from '../Assets/products/Rectangle8.png';
import ImageSlider2 from './imageslider2';

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
];

const ProductPage = () => {
  return (
    <>
      <ImageSlider2 />
      {/* <ImageSlider /> */}
      <Product_slider1 />

      {/* demo image slider */}
<section className="min-h-[40%] max-h-[40%]" loading="lazy">
  <InfiniteLooper speed={30} direction="right">
    {images.map((image, index) => (
      <div className="contentBlock contentBlock--image" key={index}>
        <img
          src={image}
          alt={`Product ${index + 1}`}
          className="product-image rounded-[15px] transform transition-transform duration-300 hover:scale-90"
        />
      </div>
    ))}
  </InfiniteLooper>

  <InfiniteLooper speed={30} direction="left">
    {images.map((image, index) => (
      <div className="contentBlock contentBlock--image" key={index}>
        <img
          src={image}
          alt={`Product ${index + 1}`}
          className="product-image rounded-[15px] transform transition-transform duration-300 hover:scale-90"
        />
      </div>
    ))}
  </InfiniteLooper>
</section>
    </>
  );
};

export default ProductPage;
